<template lang="pug">
    tbody
        template(v-for="(item, index) in items")
            slot(:item="item" :index="index")
</template>

<script>

export default {
    name: 'PaginationTableBody',
    props: {
        items: {
            type: Array,
            required: true,
        },
    },
}
</script>
